import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { useBasePath } from '@/lib/paths'
import { FileText } from 'lucide-react'
import { DocumentUploader } from '@/components/shared/DocumentUploader'
import { TemplateList } from '@/components/shared/TemplateList'

type Document = {
  id: string
  name: string
  file_url?: string | null
  blob_signed_id?: string | null
  filename?: string | null
  created_at: string
}

type Template = { id: string; name: string; file_url: string | null }

type Props = {
  registered_agent: { id: string; type_name: string; business_name: string }
  templates: Template[]
  application_documents: Document[]
}

export default function DocumentsShow({ registered_agent, templates, application_documents }: Props) {
  const basePath = useBasePath()

  return (
    <DashboardLayout
      title={`Documents — ${registered_agent.business_name}`}
      breadcrumbs={[
        { label: 'Registered Agents', href: 'registered_agents' },
        { label: registered_agent.business_name, href: `registered_agents/${registered_agent.id}` },
        { label: 'Documents' }
      ]}
    >
      <div>
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-1">
            <FileText className="w-4 h-4 text-muted-foreground" />
            <h1 className="text-xl font-semibold tracking-tight">Documents</h1>
          </div>
          <p className="text-sm text-muted-foreground">{registered_agent.business_name}</p>
        </div>

        <div className="space-y-6">
          {/* Document Templates */}
          <TemplateList title="Document Templates" templates={templates || []} />

          {/* Application Documents */}
          <DocumentUploader
            title="Application Documents"
            documents={application_documents || []}
            uploadPath={`${basePath}/registered_agents/${registered_agent.id}/application_documents`}
            deletePath={(docId) => `${basePath}/registered_agents/${registered_agent.id}/application_documents/${docId}`}
          />
        </div>
      </div>
    </DashboardLayout>
  )
}
